// extracted by mini-css-extract-plugin
module.exports = {"document":"Document_document__3PIVr","link":"Document_link__3gofJ","icon":"Document_icon__i7xLf","size":"Document_size__1Sg6g","name":"Document_name__3wLqM"};